import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { club } from "../mock";

const links = [
  { label: "Live", href: "#live", live: true },
  { label: "About", href: "#about" },
  { label: "Programs", href: "#programs" },
  { label: "Coaches", href: "#coaches" },
  { label: "Schedule", href: "#schedule" },
  { label: "Gallery", href: "#gallery" },
  { label: "News", href: "#news" },
  { label: "Teams", href: "/teams", route: true },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    if (href.startsWith("/")) { window.location.href = href; return; }
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background/90 backdrop-blur-md border-b border-white/10 py-2" : "bg-gradient-to-b from-black/70 to-transparent py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 flex items-center justify-between">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-3">
          <img src={club.crest} alt="crest" className="object-contain transition-all duration-300 drop-shadow-[0_2px_10px_rgba(229,184,51,0.35)] h-32 w-32 sm:h-40 sm:w-40" />
          <div className="leading-none text-left">
            <div className="font-display text-white text-2xl sm:text-3xl leading-none">ATLÉTICO</div>
            <div className="cond-font text-gold text-[11px] sm:text-xs tracking-[0.3em] mt-1">SOUTH FLORIDA</div>
          </div>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              className="cond-font text-sm uppercase tracking-widest text-white/80 hover:text-gold transition-colors relative group flex items-center gap-1.5"
            >
              {l.live && <span className="h-2 w-2 rounded-full bg-red-500 animate-pulse" />}
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gold transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => go("#register")}
            className="hidden sm:inline-flex cond-font uppercase tracking-widest text-sm font-semibold bg-gold text-black px-5 py-2.5 rounded-sm hover:bg-gold-light transition-colors"
          >
            Register
          </button>
          <button className="lg:hidden text-white" onClick={() => setOpen(!open)}>
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background/98 backdrop-blur-md border-t border-white/10 mt-2">
          <div className="px-5 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <button
                key={l.href}
                onClick={() => go(l.href)}
                className="cond-font text-left uppercase tracking-widest text-white/85 hover:text-gold py-3 border-b border-white/5"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => go("#register")}
              className="cond-font uppercase tracking-widest bg-gold text-black py-3 mt-3 rounded-sm font-semibold"
            >
              Register for Tryouts
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
